import React from 'react';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { Box, Typography } from '@mui/material';
import { Colors } from '../../../../assets/theme/Colors';
import routes from '../../../../routes';
import LandingDashboardCard from './LandingDashboardCard';
import OverlayLoader from '../../../../components/OverlayLoader';
import CircularProgressWithLabel from '../../../../components/CircularProgressWithValue';
import { siteGoalsTypes } from '../../../../helpers/siteGoals';
import { getPercentage } from '../../../../helpers/math';
import { sortByDateAndTime } from '../../../../helpers/sorters';

const SiteGoalsDashboardCard = ({ isLoading, siteGoals = [], id = '' }) => {
  const siteGoalsSorted = siteGoals.sort((a, b) => sortByDateAndTime('asc', a.date, b.date));
  const siteGoalsList = siteGoalsSorted.slice(0, 3); // Display only first three site goals

  if (!siteGoals.length) {
    return null;
  }

  return (
    <LandingDashboardCard title="Site Goals" to={routes.mobileDashboardSiteGoals} id={id}>
      <OverlayLoader isLoading={isLoading}>
        <Box py={2} width="100%" display="flex" gap={1} justifyContent="center" alignItems="center">
          {siteGoalsList.map((siteGoal) => (
            <CircularProgressWithLabel
              key={siteGoal.id}
              style={getPercentage(siteGoal.value, siteGoal.goal) >= 100 ? { color: Colors.green.light } : {}}
              value={getPercentage(siteGoal.value, siteGoal.goal)}
              size={100}
              thickness={2.5}
            >
              <Box sx={{ px: 1 }}>
                <Typography variant="caption" component="p" color="textSecondary">
                  {siteGoalsTypes[siteGoal.type].label}
                </Typography>
                <Typography variant="caption" component="p" color="textSecondary">
                  {Math.round(siteGoal.value)}/{siteGoal.goal}
                </Typography>
              </Box>
            </CircularProgressWithLabel>
          ))}
        </Box>
      </OverlayLoader>
    </LandingDashboardCard>
  );
};

export default SiteGoalsDashboardCard;
